<template>
    <div class="container">
      <p class="current">当前位置：<span>咨询评价</span></p>
      <div class="session-box">
        <div class="session-main">
            <div class="elForm">
               <el-form :model="ruleForm" ref="ruleForm" label-width="180px" class="disFrom">
                  
                  <el-form-item label="订单编号：">
                     
                      <p style=" width: 450px;height: 42px;margin-left: 30px;border-bottom: 1px solid #f2f2f2;">{{ ruleForm.order_no }}</p>
                  </el-form-item>
                  <el-form-item label="评论时间：" v-if="isremark == 0">
                    <p style=" width: 450px;height: 42px;margin-left: 30px;border-bottom: 1px solid #f2f2f2;"  v-if="isremark == 0">{{ ruleForm.create_time }}</p>
                  </el-form-item>
                  <el-form-item label="评分：">
                        <el-rate
                            :disabled="isremark == 0?true:false"
                            allow-half="true"
                            v-model="ruleForm.rate"
                            >
                        </el-rate>
                  </el-form-item>
                  <el-form-item label="评价内容：">
                    <el-input type="textarea" :rows="4" v-model="ruleForm.remark" placeholder="评价内容" class="InputW" style="width: 450px;margin-left: 30px;" :disabled="isremark == 0?true:false"></el-input>
                  </el-form-item>
                 
                  <el-form-item label="图片LOGO：" >
                      <div class="list-card-img">
                          <img width="200px" height="150px" v-for="item in file_items" :key="item.FileUrl" :src="item.FileUrl" alt="">
                          <el-upload
                                v-if="isremark == 0?false:true"
                              ref="upload"
                              :http-request="handleTransform"
                              action="https://qiliangong.oss-cn-shenzhen.aliyuncs.com"
                          >
                              <i class="el-icon-plus borderI" ></i>
                          </el-upload>
                      </div>
                   
                  </el-form-item>
               
                 
                  <el-form-item>
                       <el-button type="primary" style="width: 260px;margin-left: 30px;"  @click="handleJoin"  v-if="isremark == 1">确认并提交</el-button>
                       <!-- <el-button type="primary" style="width: 260px;margin-left: 30px;"  @click="handleUpdataJoin"  v-if="isremark == 0">修改并提交</el-button> -->
                   </el-form-item>
              </el-form>
           </div>
        </div>
      </div>
     
    </div>
</template>
  
  <script>
  import axios from 'axios';
//   import Menu from './index.vue'
  export default {
    data(){
      return{
        stusta: '',
        to_user_id: '',
        item_id: '',
        isremark: 1,
        ruleForm: {
            id: '',
            remark: '',
            file_items: '',
            order_no: this.$route.query.order_no,
            create_time: '',
            rate: null,

        },
        file_items: [],
        // colors: ['#99A9BF', '#99c2ff', '#66a3ff'] 
      }
    },
    components:{
    //   Menu
    },
    computed: {
        
        
    },
    methods:{
        // async vsAwait(){
          
        //     await this.getOpenIdX()
        //     this.GetInfo()
        // },
        GetInfo(data){
            this.$store.dispatch('session/remarkInfoByUser',data)
                .then(res => {
                    if(res.ok){
						this.isremark = 0
                        this.ruleForm.id = res.data.id
                        this.ruleForm.remark = res.data.content
                        this.ruleForm.order_no = res.data.order_no
                        this.ruleForm.rate = res.data.score
                        this.file_items = res.data.file_items
                        const timeDate = new Date(res.data.create_time)
                        this.ruleForm.create_time = this.getTimeDate(timeDate)
					}else{
                        // 没评价
                        this.isremark = 1
                    }
                })
        },
        getTimeDate(timeDate){
            const year = timeDate.getFullYear();
            const month = (timeDate.getMonth() + 1).toString().padStart(2, '0');
            const day = timeDate.getDate().toString().padStart(2, '0');
            const hours = timeDate.getHours().toString().padStart(2, '0');
            const minutes = timeDate.getMinutes().toString().padStart(2, '0');
            const seconds = timeDate.getSeconds().toString().padStart(2, '0');
            const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

            return formattedDate
        },
        fileToBlob(file) {
           return new Promise((resolve, reject) => {
               const reader = new FileReader();

               reader.onloadend = () => {
                   const blob = new Blob([reader.result], { type: file.type });
                   resolve(blob);
               };

               reader.onerror = reject;

               reader.readAsArrayBuffer(file);
           });
       },
       getUUID(){
           return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
               return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
           })  
       },
       handleTransform(options){
           
           console.log("上传的文件")
           console.log(options)
           let data = {}
           this.$store.dispatch('train/policy',data)
               .then(res => {
                   if(res.ok){

                       this.fileToBlob(options.file).then(blob => {
                          
                           console.log('Blob对象:', blob);
                          
                           console.log('ossPolicyX')
                           console.log(res)
                           var info = res.data
                           var key = info.dir + this.getUUID() + options.file.name.substring(options.file.name.lastIndexOf(".")) 
                           
                           console.log('key')
                           console.log(key)
                           let formData = new FormData()

                           formData.append('key', key)
                           formData.append('OSSAccessKeyId', info.accessId)
                           formData.append('policy', info.policy)
                           formData.append('signature', info.signature)
                           formData.append('success_action_status', '200')
                           formData.append('file', options.file)
                           
                           axios({
                               url: info.host,
                               contentType: false,
                               method: 'post',
                               data: formData,
                               headers: {
                                   'Content-Type': 'multipart/form-data'
                               }
                           }).then(res => {
                               const { status } = res
                               if (status === 200) {
                                   var filename = options.file.name
                                   var pictureUrl = info.host + '/' + key;//获得到的url需要将其存数据库中
                                   

                                   this.file_items.push({
                                       filename: filename,
                                       lanmu: 'booking',
                                       picurl: pictureUrl,
                                       FileName: filename,
                                       FileUrl: pictureUrl,

                                   })  
                                   this.$forceUpdate();
                               } 
                           })
                    
                       });
                       
                       
                   }
               })
          
       },
        // 提交表单
        handleJoin(){
               if (this.ruleForm.remark != '') {
                    if(this.file_items.length != 0){
                        var files = JSON.stringify(this.file_items)
                    }else{
                        var files = []
                    }
                    let data = {
                        id: '',
                        xcate: 'expert',
                        xid: this.to_user_id,
                        content: this.ruleForm.remark,
                        file_items: files,
                        order_no: this.ruleForm.order_no,
                        item_id: this.item_id,
                        score: this.ruleForm.rate
                    }
                    this.$store.dispatch('session/remarkAdd',data)
                        .then(res => {
                            this.$notify({
                                title: '标题',
                                message: "提交成功",
                                type: "success"
                              })
                            var data = {
                                xcate: 'expert',
                                xid: this.to_user_id,
                                order_no: this.ruleForm.order_no,
                                item_id: this.item_id
                            }
                            this.GetInfo(data)
                        })
               }else{
                this.$notify({
                    title: '提示',
                    message: '评价内容不能为空',
                    type: 'error'
                })
               }
        },
        handleUpdataJoin(){
            if (this.ruleForm.remark != '') {
                    
                    if(this.file_items.length != 0){
                        var files = JSON.stringify(this.file_items)
                    }else{
                        var files = []
                    }
                    let data = {
                        id: this.ruleForm.id,
                        xcate: 'expert',
                        xid: this.to_user_id,
                        content: this.ruleForm.remark,
                        file_items: files,
                        order_no: this.ruleForm.order_no,
                        item_id: this.item_id
                    }
                    this.$store.dispatch('session/remarkUpdata',data)
                        .then(res => {
                            if(res.ok){
                              this.$notify({
                                title: '标题',
                                message: "修改成功",
                                type: "success"
                              })
                            }
                            var data = {
                                xcate: 'expert',
                                xid: this.to_user_id,
                                order_no: this.ruleForm.order_no,
                                item_id: this.item_id
                            }
                            this.GetInfo(data)
                        })
               }else{
                this.$notify({
                    title: '提示',
                    message: '评价内容不能为空',
                    type: 'error'
                })
               }
        }
    },
    created(){
        this.stusta = this.$route.query.stusta
        this.to_user_id = this.$route.query.to_user_id
        this.order_no = this.$route.query.order_no
        this.item_id = this.$route.query.item_id

       
        var data = {
            xcate: 'expert',
            xid: this.to_user_id,
            order_no: this.ruleForm.order_no,
            item_id: this.item_id
        }

        this.GetInfo(data)
        // if(this.stusta == 'start'){
        //     this.getDate('start');
        // }else{
        //     this.getDate('end')
        // }
    },
  }
  </script>
  
  <style lang='scss' scoped>
  
  .container{
    width: 1200px; min-height: calc(100vh - 215px);
    margin: 55px auto;
    .current{
      margin-top: -45px;
      position: relative;
      font-size: 17px;
      color: #333;
    }
    .session-box{
        margin-top: 10px;
        width: 100%;
      .session-main{
        
        height: calc(100vh - 195px);
        background: #fff;
        padding: 10px 10px;
        position: relative;
        .elForm{
            width: 880px;
            margin: 20px auto;
            ::v-deep .disFrom{
                .el-upload-list__item{
                    display: none !important;
                }
                .el-upload-list__item-name{
                    display: none !important;
                }

                .el-rate{
                    height: 40px !important;
                    line-height: 3 !important;
                    margin-left: 30px !important;
                }
            }
            .list-card-img{
                display: flex;
                justify-content: flex-start;
                flex-flow: row wrap;
                margin-left: 30px;
                img{
                    margin: 5px 5px;
                }
            }
            .borderI{
                text-align: center;
                cursor: pointer;
                width: 200px;
                outline: 0;
                height: 150px;
                line-height: 150px;
                border-radius: 5px;
                border: 1px dashed #999999;
                font-size: 20px;
                color: #999999;
                margin-left: 5px;
            }
        }
      }
    }
  }
  
  ul{
    margin: 0 0;
    padding: 0 0;
    font-size: 14px;
    color: #333333;
    li{
      margin: 3px 5px;
      cursor: pointer;
      height: 52px;
      line-height: 52px;
      font-size: 18px;
      color: #303133;
    }
    li:hover{
      color: #00a8a8;
    }
  }
  .activeColor{
    color: #00a8a8;
  }
  </style>